export const documentConstants = {
    ID_DOCUMENTS_LOADING: 'ID_DOCUMENTS_LOADING',
    ID_DOCUMENTS_SUCCESS: 'ID_DOCUMENTS_SUCCESS',
    ID_DOCUMENTS_FAILED: 'ID_DOCUMENTS_FAILED',
    
    ACCOUNT_DOCUMENTS_LOADING: 'ACCOUNT_DOCUMENTS_LOADING',
    ACCOUNT_DOCUMENTS_SUCCESS: 'ACCOUNT_DOCUMENTS_SUCCESS',
    ACCOUNT_DOCUMENTS_FAILED: 'ACCOUNT_DOCUMENTS_FAILED',
    
    FETCH_DOCUMENT_IMG_BY_ID_LOADING: "FETCH_DOCUMENT_IMG_BY_ID_LOADING",
    FETCH_DOCUMENT_IMG_BY_ID_SUCCESS: "FETCH_DOCUMENT_IMG_BY_ID_SUCCESS",
    FETCH_DOCUMENT_IMG_BY_ID_FAILED: "FETCH_DOCUMENT_IMG_BY_ID_FAILED",

    CALCULATE_USER_HASH_LOADING: 'CALCULATE_USER_HASH_LOADING',
    CALCULATE_USER_HASH_SUCCESS: 'CALCULATE_USER_HASH_SUCCESS',
    CALCULATE_USER_HASH_FAILED: 'CALCULATE_USER_HASH_FAILED',
    
    FETCH_DOCUMENT_BY_ID_TOKEN_SUCCESS: 'FETCH_DOCUMENT_BY_ID_TOKEN_SUCCESS',
    FETCH_DOCUMENT_BY_ID_TOKEN_FAILED: 'FETCH_DOCUMENT_BY_ID_TOKEN_FAILED',
    
    FETCH_DOCUMENT_BY_HASH_ID_LOADING: 'FETCH_DOCUMENT_BY_HASH_ID_LOADING',
    FETCH_DOCUMENT_BY_HASH_ID_SUCCESS: 'FETCH_DOCUMENT_BY_ID_SUCCESS',
    FETCH_DOCUMENT_BY_HASH_ID_FAILED: 'FETCH_DOCUMENT_BY_ID_FAILED',
 
    ID_DOCUMENTS_UPDATED_SUCCESS: 'ID_DOCUMENTS_UPDATED_SUCCESS',
    ID_DOCUMENTS_UPDATED_FAILED: 'ID_DOCUMENTS_UPDATED_FAILED',
    ID_DOCUMENTS_UPDATED_LOADING: 'ID_DOCUMENTS_UPDATED_LOADING',
    
    ID_DOCUMENTS_UPLOAD_SUCCESS: 'ID_DOCUMENTS_UPLOAD_SUCCESS',

    IS_MY_DOCUMENTS_ENABLED_SUCCESS: 'IS_MY_DOCUMENTS_ENABLED_SUCCESS',

    CLEAN_DOCUMENTS_STATE: 'CLEAN_DOCUMENTS_STATE',    
}